<template>
  <div>
    <header>
      <div class="container-fluid home_header">
        <div class="d-flex justify-content-between">
          <button
            class="btn btn-link bd-search-docs-toggle d-md-none p-0 ml-3 collapsed"
            type="button"
            data-toggle="collapse"
            data-target="#bd-docs-nav"
            aria-controls="bd-docs-nav"
            aria-expanded="false"
            aria-label="Toggle docs navigation"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 30 30"
              width="30"
              height="30"
              focusable="false"
            >
              <title>Menu</title>
              <path
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-miterlimit="10"
                d="M4 7h22M4 15h22M4 23h22"
              ></path>
            </svg>
          </button>
          <h1 class="text-hide xinhua mr-3 ml-1"></h1>
          <div class="search-content">
            <div class="input-group" ref="inputGroup">
              <div class="input-group-prepend">
                <button
                  class="btn btn-outline-secondary dropdown-toggle btn-sm type-button"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  {{ searchTypeValue | searchKey }}
                </button>
                <div class="dropdown-menu nano statenano">
                  <div class="nano-content nano-contents">
                    <a
                      class="dropdown-item"
                      v-for="(value, key) in searchObjType"
                      @click="filtrateState(key, value)"
                      href="javascript:;"
                      >{{ key }}</a
                    >
                  </div>
                </div>
                <!--                                <input type="text" class="form-control" aria-label="Text input with dropdown button"-->
                <!--                                >-->
                <div class="input_box">
                  <input
                    type="text"
                    @blur.prevent="changeCount()"
                    @click="navSearch()"
                    v-model="searchmatter"
                    maxlength="500"
                    class="form-control pl-4"
                    @input="changeSearch"
                    placeholder="Search keywords"
                    v-on:keyup.enter="routerClick(searchmatter)"
                  />
                  <div
                    class="nav_search"
                    v-show="
                      showSearch &&
                      (!searchmatter ||
                        (this.searchSuggest && this.searchSuggest.length))
                    "
                  >
                    <!--              搜索联想内容-->
                    <div
                      v-show="this.searchSuggest && this.searchSuggest.length"
                    >
                      <div v-for="(item, index) in searchSuggest" :key="index">
                        <div
                          v-if="index < 5"
                          class="search-suggest"
                          @click="routerClick(item.v, true)"
                        >
                          <!--                    <p>{{suggestType[item.k]}}</p>-->
                          <p>{{ item.v }}</p>
                        </div>
                      </div>
                    </div>
                    <!--                            新华社热词-->
                    <div
                      v-show="!this.searchSuggest || !this.searchSuggest.length"
                    >
                      <div class="nav_search_title">
                        <img
                          src="../../../assets/images/silkRoadBase/rsh@2x.png"
                          class="img-fluid mr-2"
                          style="width: 15px; height: 15px"
                        />
                        <!-- <img src="../../../assets/images/silkRoadBase/rsh@2x.png" class="img-fluid mr-2" style="width: 20px; height: 20px;"> -->
                        <span>Top search</span>
                      </div>

                      <div class="nav_search_content">
                        <div class="nav_search_content_li">
                          <div
                            @click="routerClick(item.name)"
                            v-for="item in searchText"
                            :key="item.name"
                          >
                            {{ item.name }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <router-link
                    :to="routerParams(this.searchmatter)"
                    class="border border-0"
                  >
                    <i class="fa fa-search fa-lg search_icon text-muted"></i>
                  </router-link>
                </div>
              </div>
            </div>
            <advance-search
              v-model="advancedSearchState"
              :domParameter="seachDom"
              ref="searchAdvance"
              @searchAdvance="searchAdvance"
              :tableList="tableList"
            ></advance-search>
            <div
              class="advance-search-text f14 text-dark font-weight-bold cursor hidden-sm"
              @click="advancedSearchState = advancedSearchState === 0 ? 1 : 0"
            >
              {{ !advancedSearchState ? "Advanced Search" : "Ordinary Search" }}
            </div>
          </div>
          <!--<div class="my_pc paper_btn">

                    </div>-->

          <!--                    <div class="input_box_move offset-md-1 col-2 d-block d-md-none">-->
          <!--                        <router-link :to="{name:'searchresult', params :{keyword:this.searchmatter}}"-->
          <!--                                     class="border border-0">-->
          <!--                            <i class="fa fa-search fa-lg search_icon text-dark"></i>-->
          <!--                        </router-link>-->
          <!--                    </div>-->

          <div class="my_pc pl-3 pull-right">
            <div class="float-right paper_btn">
              <!--<a href="http://new.wanfangdata.com.cn/index.html" target="_blank" class="btn btn-outline-primary mr-3 btn-sm">
                                Paper search
                            </a>-->
              <a
                href="https://www.imsilkroad.com/db"
                target="_blank"
                class="btn btn-outline-primary mr-3 btn-sm"
                >中文</a
              >
              <div
                class="dropdown"
                style="display: inline-block; font-size: 1.2222em"
              >
                <i
                  class="fa fa-mobile fa-lg btns text-dark mr-3"
                  data-toggle="dropdown"
                  @click="app()"
                ></i>
              </div>
              <div class="dropdown" style="display: inline-block">
                <i
                  class="fa fa-user fa-lg btns text-dark mr-3"
                  data-toggle="dropdown"
                ></i>
                <div class="dropdown-menu p-0 mt-3" style="margin-left: -63px">
                  <li
                    class="list-group-item p-0 text-center text-light"
                    style="height: 40px; line-height: 40px"
                  >
                    <router-link
                      to="/accountSettings"
                      class="nav-link text-dark"
                    >
                      User center
                    </router-link>
                  </li>
                  <li
                    class="list-group-item p-0 text-center text-light"
                    style="height: 40px; line-height: 40px"
                  >
                    <router-link to="/feedback" class="nav-link text-dark">
                      Demand feedback
                    </router-link>
                  </li>
                  <li
                    class="list-group-item p-0 text-center text-light"
                    style="height: 40px; line-height: 40px"
                  >
                    <a href="javascript:" class="text-dark" @click="loginOut()"
                      >Log out</a
                    >
                  </li>
                </div>
              </div>

              <span class="register_name ml-2 smnone f14">
                <input type="hidden" :value="this.userid" class="uservalue" />
                Welcome：{{ this.username }}
              </span>
            </div>
          </div>
          <!--<div class="my_move col-2 d-block d-md-none">
                        <i class="fa fa-user fa-lg my_img"></i>
                    </div>-->
        </div>
      </div>
    </header>
  </div>
</template>
<script>
import User from "./user.js"; //引用模块进来
import { baseUrl, othersHotWords, querySuggest } from "@/common/js/http/pdBase";
import * as _ from "lodash";
import AdvanceSearch from "@/views/search/advanceSearch";
import store from "@/store"; // Vuex

const searchObjType = {
  All: "All",
  "Real-time Info": "Real-time Info",
  Report: "Report",
  Video: "Video",
  // 'Reports': 'Reports'
};
export default {
  name: "headPage",
  components: {
    AdvanceSearch,
  },
  data: function () {
    return {
      searchTypeValue: "All",
      searchmatter: "",
      searchObjType: searchObjType,
      advancedSearchState: 0,
      searchType: {
        "Real-time Info": [{ name: "articleId" }],
        Reports: [
          { name: "report", params: { id: 5020 } },
          { name: "report", params: { id: 5019 } },
          { name: "countryreport" },
          { name: "intellectual" },
        ],
      },
      username: "",
      userid: "",
      searchData: {},
      showSearch: false,
      searchText: [],
      searchSuggest: [], // pd搜索联想
      throttleTime: null, // 联想定时器
      seachDom: null,
      tableList: [],
    };
  },
  watch: {
    $route: {
      handler(newValue) {
        if (newValue.name) {
          // debugger
          let text = "";
          if (newValue.params && newValue.params.keyword) {
            text = newValue.params.keyword;
          }
          let type = this.creatSearchType();
          if (newValue.name === "SearchType") {
            type = this.$route.params.type;
          } else if (newValue.name === "searchDetail") {
            const params =
              newValue.params && newValue.params.pathMatch.split("/");
            type = (params.length && params[params.length - 3]) || "All";
            text = (params.length && params[params.length - 1]) || "";
          } else {
            type = searchObjType[type];
          }
          this.searchTypeValue = type || "All";
          this.searchmatter = text;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created: function () {
    this.getTableList();
    var self = this;
    this.$axios.post("/api/pc/getmembername", {}).then((data) => {
      var str = location.href;
      var num = str.indexOf("#");
      str = str.substr(num + 1);
      if (data.data.state) {
        if (data.data.data.username == "") {
          location.href = "/login#" + str;
        }
        self.username = data.data.data.username;
        self.userid = data.data.data.id;
        User.loginName = data.data.data.username;
        User.loginId = data.data.data.id;
        store.commit("group_id", data.data.data.group_id);
        this.$eventBus.$emit("userInfoUpdate", true);
      } else {
        location.href = "/login#" + str;
      }
    });
  },
  mounted() {
    this.$nextTick(() => {
      const { left, width } = this.$refs.inputGroup.getBoundingClientRect();
      this.seachDom = { left, width };
    });
  },
  methods: {
    // 热搜
    navSearch() {
      // let _that = this
      // this.showSearch = true
      // this.$axios.post('/api/pc/gethotsearch').then(response => {
      //   if (response.data.state) {
      //     this.searchText = response.data.data
      //   }
      // })
      if (document.body.clientWidth > 768) {
        const data = {
          pageNo: 1,
          pageSize: 10,
          docType: "Real-time Info",
        };
        othersHotWords(data).then((data) => {
          if (data.errCode === 200) {
            const _data = data.data.rsData;
            this.searchText = _.map(_data, (item) => {
              item.name = item.word;
              return item;
            });
          } else {
            this.searchText = [];
          }
          this.showSearch = true;
        });
      }
    },
    creatSearchType() {
      for (let key in this.searchType) {
        const routeArr = this.searchType[key];
        for (let item of routeArr) {
          const params = item.params;
          if (item.name === this.$route.name) {
            if (!params || params.id === ~~this.$route.params.id) {
              return key;
            }
          }
        }
      }
    },
    filtrateState(key, value) {
      this.searchTypeValue = value;
      if (this.$route.path.indexOf("searchType") !== -1) {
        //  已近进入搜索页
        const params = this.$route.params;
        params.type = value;
        this.$router.push({ params });
      }
    },
    changeCount() {
      setTimeout(() => {
        this.showSearch = false;
        this.searchSuggest = [];
      }, 500);
    },
    routerParams(item) {
      console.log(this.$route, "this.$route-this.$route");
      const obj = {
        // name: 'searchType',
        path: "",
        params: {
          type: this.$route.path.includes("/consult_particulars_organization")
            ? this.searchTypeValue || "All"
            : this.$route.params.type || this.searchTypeValue || "All",
          keyword: item,
        },
      };
      // const typeObj = this.replaceType(item)
      // if (typeObj.type) {
      //   obj.params.type = typeObj.type
      //   obj.params.keyword = typeObj.kw
      // }
      let path = `${this.createdPath()}/${obj.params.type}/${1}/${
        obj.params.keyword
      }`;
      obj.path = path;
      return obj;
    },
    createdPath() {
      let path = "/searchType";
      if (this.$route && this.$route.path) {
        const index = this.$route.path.indexOf("searchType");
        if (index === -1) {
          path = this.$route.path + path;
        } else {
          const snippet = this.$route.path.slice(0, index + 10);
          path = snippet;
        }
      }
      return path;
    },
    routerClick(item, type = false) {
      if (this.throttleTime) {
        clearTimeout(this.throttleTime);
      }
      let route = this.routerParams(item);
      if (type) {
        const search = this.replaceType(this.searchmatter);
        if (search.type) {
          route.params.type = search.type;
        }
      }
      this.showSearch = false;
      this.searchSuggest = [];
      route.path = `${this.createdPath()}/${route.params.type}/${1}/${
        route.params.keyword
      }`;
      this.searchmatter = item;
      this.$router.push(route);
    },
    replaceType(item) {
      const obj = {
        kw: item,
        // type: 'All'
        type: this.searchTypeValue || "All",
      };
      // for (let type of this.searchArr) {
      //   const index = item.indexOf(type + ':')
      //   if (index === 0) {
      //     obj.type = this.searchObjType[type]
      //     // obj.kw = item.replace(type + ':', '') || ' '
      //   }
      // }
      return obj;
    },
    loginOut: function () {
      // window.location.href = '/quit'
      let _this = this;
      this.$axios.post("/api/pc/loginout", {}).then(function (data) {
        if (data.data.state) {
          let promiseArr = [];
          // 动态加载js 脚本
          var scriptReg = /<script.*?(?:>|\/>)/gi;
          // //匹配src属性
          var srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i;
          var arr = data.data.data.js_script.match(scriptReg);
          for (var i = 0; i < arr.length; i++) {
            var src = arr[i].match(srcReg);
            console.log("scr" + i, src);
            // //获取url地址
            if (src[1]) {
              promiseArr.push(
                _this.$axios.get(src[1],{})
              );
            }
          }
          window.Promise.allSettled(promiseArr)
            .then((res) => {
              window.location.href = "/login";
            })
            .catch((error) => {
              console.log(error);
            });
          // setTimeout(() => {
          //   window.location.href = "/login";
          // }, 2000);
        }
      });
    },
    app() {
      window.open("/app", "_blank");
    },
    // 搜索接口
    pdSearch() {
      const data = {
        docTypeList: ["Real-time Info"],
        finField: ["city", "country", "enterprise", "organization", "province"],
        kw: this.searchmatter,
      };
      return querySuggest(data).then((data) => {
        if (data.data.errCode === 200) {
          this.searchSuggest = data.data.data;
        }
        return Promise.resolve();
      });
    },
    // 搜索词联想
    changeSearch() {
      if (this.throttleTime) {
        clearTimeout(this.throttleTime);
      }
      this.throttleTime = setTimeout(() => {
        this.pdSearch().then((data) => {
          this.showSearch = true;
        });
      }, 500);
    },
    getTableList() {
      this.$axios({
        method: "GET",
        url: "/search/find/column/en",
        baseURL: baseUrl,
      }).then((data) => {
        if (data.data.errCode === 200) {
          _.forEach(data.data.data, (item) => {
            item.config = JSON.parse(item.config);
          });
          this.tableList = data.data.data;
        }
      });
    },
    searchAdvance(val, jump = true) {
      // 高级搜索
      if (jump) {
        let route = this.routerParams("");
        if (val.type) {
          route.params.type = val.type;
        }
        localStorage.setItem(
          "advanceQuery",
          JSON.stringify(val.hightQueryBean)
        );
        route.path = `${this.createdPath()}/${route.params.type}/${1}/${
          route.params.keyword
        }?advanced=true&select=${val.selectId}`;
        // this.searchmatter = item
        this.$eventBus.$emit("isAdvanced", true);
        this.$router.push(route);
      }
      this.advancedSearchState = 0;
    },
  },
  filters: {
    searchKey(value) {
      for (let key in searchObjType) {
        if (searchObjType[key] === value) {
          return key;
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@media only screen and (max-width: 767px) {
  .hidden-sm {
    display: none !important;
  }
}

// 清除input点击效果
.form-control:focus {
  /*清除input框focus出现的边框*/
  border-color: rgba(226, 227, 228, 1);
  webkit-box-shadow: none;
  box-shadow: none;
}

.form-control {
  padding-right: 38px;
}

.dropdown:hover {
  cursor: pointer;
}

@media only screen and (max-width: 766px) {
  .nav_search {
    display: none;
  }
}

@media screen and(max-width: 766px) {
  .home_header {
    height: 63px;

    & > div {
      height: 60px;
    }
  }

  .input_box {
    display: block !important;
    height: 32px;
    line-height: 32px !important;
    margin-left: 0 !important;

    input {
      height: 32px !important;
      line-height: 32px !important;
    }

    .search_icon {
      left: 80% !important;
      line-height: 32px !important;
    }
  }
}

.column_active {
  background: transparent !important;
}

.home_header {
  .border {
    position: initial;

    &::before {
      border: none;
    }
  }
}

.show {
  display: inline-block !important;
}

.input-group-prepend {
  width: 100%;

  .dropdown-toggle {
    min-width: 50px;
  }
}

.dropdown:hover {
  cursor: pointer;
}

.search-content {
  display: flex;
  justify-content: center;
  width: 45%;
  align-items: center;
  position: relative;

  .input-group {
    width: calc(100% - 150px);
  }

  .input-group-prepend.show {
    display: flex !important;
  }

  .input_box {
    flex: 1 1;

    input {
      border-radius: 0;
      height: 40px;
      margin-top: 0;
      background: #ffffff;
    }

    .search_icon {
      right: 20px;
      left: auto;
      top: 0;
    }
  }

  .dropdown-menu {
    height: 148px !important;

    a {
      line-height: 30px;
    }
  }

  .advance-search-text {
    position: absolute;
    right: 0;
    width: 70px;
    height: 62px;
    /*display: flex;*/
    margin-left: 2%;
    text-align: center;
    flex-shrink: 0;
    cursor: pointer;
    padding: 9px 0 0 0;

    &:hover {
      color: #007bff !important;
    }
  }
}

.search-suggest {
  display: flex;
  align-content: center;
  /*padding: 4px 0;*/
  cursor: pointer;

  p {
    line-height: 37px;
  }

  /*p:nth-child(1) {*/
  /*  width: 18%;*/
  /*  color: #999;*/
  /*  font-size: 13px;*/
  /*}*/

  p:nth-child(1) {
    width: 90%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 14px;
  }
}

.type-button {
  border-color: rgba(226, 227, 228, 1);
  border-right: none;
}

.disabled {
  cursor: not-allowed;
}

.nav_search {
  box-shadow: 0 0 5px 0px #dedddd !important;
}

@media screen and (max-width: 768px) {
  .search-content {
    width: calc(100% - 1rem - 30px - 10rem - 1rem - 0.25rem);

    .input-group {
      width: 100% !important;
    }
  }
}
</style>

<style lang="scss">
.el-popup-parent--hidden {
  padding: 0 !important;
}
</style>
